import PropTypes from 'prop-types';
import authService, { privileges } from '../../services/AuthService';

const CanCreate = ({ on = null, children, fallback }) => {
  if (!children) return null;
  if (on) {
    if (
      !authService.hasPermission({
        functionality: on,
        privilege: privileges.Create,
      })
    )
      return fallback;
  }

  return children;
};

CanCreate.propTypes = {
  on: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node,
  fallback: PropTypes.node,
};
CanCreate.defaultProps = {
  on: null,
  children: null,
  fallback: null,
};
export default CanCreate;
